import { useCallback, useRef } from "react";

export default function useCallbackStable<T extends unknown[], U>(
  callback: (...args: T) => U
): (...args: T) => U {
  const callbackRef = useRef(callback);

  // Update the ref to the latest callback on each render
  callbackRef.current = callback;

  // Return a stable callback function
  return useCallback((...args: T) => {
    return callbackRef.current(...args);
  }, []);
}
